'use client';

import { setgoogleIdCookies } from 'app/actions/affiliate.actions';
import { usePathname, useSearchParams } from "next/navigation";
import { ReactNode, useEffect } from "react";
import { cn } from 'utils/cn';



export function NavbarWrapper({ children }: { children: ReactNode }) {
    const pathname = usePathname()
    const searchParams = useSearchParams();    
    useEffect(() => {
      const gclid = searchParams.get('gclid');
      const msclkid = searchParams.get('msclkid');
      if (gclid) {
        setgoogleIdCookies({gclid});
      }
      if (msclkid) {
        setgoogleIdCookies({msclkid});
      }

    }, [pathname])

    if(pathname.includes('build-your-own')) return null

  return (
    <div className={cn('')}>
      {children}
    </div>
  );
}